
import { ref, onMounted, onUnmounted, onUpdated, defineComponent } from 'vue'
export default defineComponent({
    props:{
        text: {
            type: String,
            required: true
        },
        lines: {
            type: Number,
            default: 2
        }
    },
    setup(props){

        const isExpanded = ref(false)
        const showButton = ref(false)
        const textRef = ref<HTMLDivElement>()

        // 检测文本是否溢出
        const checkOverflow = () => {
            if (!textRef.value) return
            
            const style = window.getComputedStyle(textRef.value!)
            const lineHeight = parseFloat(style.lineHeight) || parseFloat(style.fontSize) * 1.2
            const maxHeight = lineHeight * props.lines
            const actualHeight = textRef.value && textRef.value.scrollHeight
            showButton.value = actualHeight > maxHeight
        }

        // 处理窗口大小变化
        const handleResize = () => {
            checkOverflow()
        }

        // 生命周期钩子
        onMounted(() => {
            checkOverflow()
            window.addEventListener('resize', handleResize)
        })

        onUpdated(checkOverflow)

        onUnmounted(() => {
            window.removeEventListener('resize', handleResize)
        })

        // 切换展开状态
        const toggleExpand = () => {
            isExpanded.value = !isExpanded.value
        }
        return{
            toggleExpand,
            isExpanded,
            showButton,
            textRef
        }
    }

})
